import React, { useState } from 'react';
import './css/index.scss';
import MyButton from '../MyButton';
import DeletePhotoIcon from '../../assets/formIcons/deletePhoto.svg';
import { isPhotoUrl, normalizePhotoUrls } from '../../helpers/photoUrls';

/**
 * Поле ссылок на картинки. Можно вставить несколько сразу — через пробел, запятую или с новой строки.
 */
function PhotoUrlField({
  urls = [],
  onChange,
  max = 15,
  showList = true,
  disabled = false,
}) {
  const [text, setText] = useState('');
  const [error, setError] = useState('');

  const addUrls = () => {
    const parts = text.split(/[\s,]+/).map((item) => item.trim()).filter(Boolean);
    if (!parts.length) {
      setError('Вставьте ссылку http или https.');
      return;
    }

    const valid = parts.filter((item) => isPhotoUrl(item));
    const invalid = parts.length - valid.length;
    if (!valid.length) {
      setError('Нужна прямая ссылка, которая начинается с http:// или https://.');
      return;
    }

    const room = Math.max(0, max - urls.length);
    const next = normalizePhotoUrls([...urls, ...valid]).slice(0, max);
    const added = next.length - urls.length;
    onChange(next);
    setText('');

    if (!room || added < valid.length) {
      setError(`В карусель помещается не больше ${max} фото. Лишние ссылки не добавлены.`);
    } else if (invalid) {
      setError(`Пропущено не-ссылок: ${invalid}.`);
    } else {
      setError('');
    }
  };

  return (
    <div className="photo_url_field">
      <div className="photo_url_field_row">
        <input
          className="photo_url_field_input"
          placeholder="https://… ссылка на картинку"
          value={text}
          disabled={disabled || urls.length >= max}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addUrls();
            }
          }}
        />
        <MyButton
          text="По ссылке"
          onClick={addUrls}
          secondary
          disabled={disabled || urls.length >= max || !text.trim()}
          className="photo_url_field_button"
        />
      </div>
      <p className="photo_url_field_hint">
        Файл не скачивается: в карточку сохранится сама ссылка. Несколько ссылок можно вставить сразу.
      </p>
      {error ? <p className="photo_url_field_error">{error}</p> : null}

      {showList && urls.length ? (
        <div className="photo_url_field_grid">
          {urls.map((url) => (
            <div key={url} className="photo_url_field_item">
              <img src={url} alt="" />
              <button
                type="button"
                className="photo_url_field_remove"
                aria-label="Удалить"
                onClick={() => onChange(urls.filter((item) => item !== url))}
                disabled={disabled}
              >
                <img src={DeletePhotoIcon} alt="" />
              </button>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default PhotoUrlField;
